import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IBuildingType } from '@api/types'
import { BuildingTypeFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: {
        types: { buildingType: IBuildingType[] }
      }
    }
  }
}

export default function buildingTypes(): Promise<IBuildingType[]> {
  return client.gql.query({ query: buildingTypesQuery }).then(
    ({
      data: {
        viewer: {
          company: {
            types: { buildingType },
          },
        },
      },
    }: Payload) => buildingType
  )
}

export const buildingTypesQuery = gql`
  query buildingTypes {
    viewer {
      company {
        types {
          buildingType {
            ...BuildingTypeFragment
          }
        }
      }
    }
  }
  ${BuildingTypeFragment}
`
